import { render } from "./ideaList.vue?vue&type=template&id=983ab05c&scoped=true"
import script from "./ideaList.vue?vue&type=script&lang=js"
export * from "./ideaList.vue?vue&type=script&lang=js"

import "./ideaList.vue?vue&type=style&index=0&id=983ab05c&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.www/src/fe-www/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-983ab05c"]])

export default __exports__